import config from './package.json';
import { ModuleConfig } from '../../types/configTypes';
import saga from './sagas';
import MyPrivilegesCardViewRegistry from '../../registries/MyPrivilegesCardViewRegistry';
import HappyAgeingCardView from './containers/MyPrivilegesCardView';
import HappyAgeingDetailsView from './containers/MyPrivilegesDetailsView';
import myPrivilegesSaga from '../myPrivileges/sagas';

MyPrivilegesCardViewRegistry.register(
  config.id,
  HappyAgeingCardView,
  HappyAgeingDetailsView,
  false,
  config.myPrivigesReducerSubName,
);

export default {
  config,
  sagas: [saga, myPrivilegesSaga],
} as ModuleConfig;
